import theme from '@/app/providers/theme';
import { Box, Autocomplete } from '@mui/material';
import { EditTextField } from '@/shared/UI/styled/global';
import { Controller, useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { UseAppDispatch } from '@/shared/store';
import { CompaniesSlice } from '@/shared/store/controllers/CompaniesSlice';

const CompaniesFilters = () => {
  const appDispatch = UseAppDispatch();

  const {
    control,
    setValue,
    getValues,
    formState: { isValid },
  } = useForm<any>({
    mode: 'onChange',
  });

  const statuses = [
    { id: 0, value: '0', label: 'Not active' },
    { id: 1, value: '1', label: 'Active' },
  ];

  const [companyName, setCompanyName] = useState<string>('');
  const [dotNumber, setDotNumber] = useState<string>('');
  const [id, setId] = useState<string>('');
  const [isActive, setIsActive] = useState<{
    id: number;
    value: string;
    label: string;
  } | null>(null);

  const setFilters = async () => {
    const data = getValues();
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(
        ([_, value]) => value !== undefined && value !== null && value !== '',
      ),
    );
    await appDispatch(
      CompaniesSlice.actions.setFilters(Object.assign({}, filteredData)),
    );
  };

  useEffect(() => {
    setFilters();
  }, [companyName, dotNumber, id, isActive]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFilters();
  };

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column',
        },
      }}
      onSubmit={handleSubmit}
    >
      <Box sx={{ marginRight: '10px' }}>
        <Controller
          control={control}
          name="name"
          render={({ field, fieldState: { error } }) => (
            <EditTextField
              {...field}
              value={companyName || ''}
              onChange={async e => {
                const value = e.target.value;
                setCompanyName(value);
                setValue('name', value);
              }}
              InputLabelProps={{ shrink: false }}
              label="Name"
              placeholder="Search by name"
              sx={{ maxWidth: '297px', marginRight: '20px' }}
              error={error !== undefined}
            />
          )}
        />
      </Box>
      <Box sx={{ marginRight: '10px' }}>
        <Controller
          control={control}
          name="dot_number"
          render={({ field, fieldState: { error } }) => (
            <EditTextField
              {...field}
              value={dotNumber || ''}
              onChange={async e => {
                const value = e.target.value;
                setDotNumber(value);
                setValue('dot_number', value);
              }}
              InputLabelProps={{ shrink: false }}
              label="Dot number"
              placeholder="Search by dot dumber"
              sx={{ maxWidth: '297px', marginRight: '20px' }}
              error={error !== undefined}
            />
          )}
        />
      </Box>
      <Box sx={{ marginRight: '10px' }}>
        <Controller
          control={control}
          name="id"
          render={({ field, fieldState: { error } }) => (
            <EditTextField
              {...field}
              value={id || ''}
              onChange={async e => {
                const value = e.target.value;
                setId(value);
                setValue('id', value);
              }}
              InputLabelProps={{ shrink: false }}
              label="ID"
              placeholder="Search by id"
              sx={{ maxWidth: '297px', marginRight: '20px' }}
              error={error !== undefined}
            />
          )}
        />
      </Box>
      <Box sx={{ marginRight: '10px', width: '200px' }}>
        <Controller
          control={control}
          name="status"
          render={({ field, fieldState: { error } }) => (
            <Autocomplete
              {...field}
              value={isActive}
              onChange={(_, newValue) => {
                setIsActive(newValue);
                setValue('is_active', newValue ? newValue.value : '');
              }}
              options={statuses}
              getOptionLabel={option => option.label}
              isOptionEqualToValue={(option, value) =>
                option.value === value?.value
              }
              clearOnEscape
              clearText="Clear"
              disableClearable={false}
              renderInput={params => (
                <EditTextField
                  {...params}
                  label="Status"
                  placeholder="Select status"
                  InputLabelProps={{ shrink: false }}
                  error={error !== undefined}
                  sx={{ maxWidth: '297px', marginRight: '20px' }}
                />
              )}
            />
          )}
        />
      </Box>
    </Box>
  );
};

export default CompaniesFilters;
